import BaseTable, { ColumnType } from "../../../components/elements/BaseTable"
import { AbsenceType } from "../types"
import AbsenceTableRow from "./AbsenceTableRow"

type AllTasksTableType = {
    absence?: AbsenceType[]
    handleUpdateAbsence: (id: string, body: AbsenceType) => void
    openAbsenceModal: (item: AbsenceType) => void
    userIsEmployee: boolean
}

export default function OrderRequestTable(props: AllTasksTableType) {
    const orderRequestTableColumns: ColumnType[] = [
        {
            label: "Abwesenheit",
        },
        {
            label: "Mitarbeiter",
            responsive: props.userIsEmployee ? "hidden" : "",
        },
        {
            label: "Erstellt am",
        },
        {
            label: "Start",
        },
        {
            label: "Ende",
        },
        {
            label: "Notiz",
            responsive: "hidden lg:table-cell",
        },
        {
            label: "Status",
        },
        {
            label: "",
            responsive: props.userIsEmployee ? "hidden" : "",
        },
    ]

    return (
        <BaseTable
            columns={orderRequestTableColumns}
            tbody={props.absence?.map(
                (item) =>
                    item &&
                    item.employee?.first_name &&
                    item.employee?.last_name && (
                        <AbsenceTableRow absence={item} openAbsenceModal={() => props.openAbsenceModal(item)} handleUpdateAbsence={props.handleUpdateAbsence} userIsEmployee={props.userIsEmployee} />
                    )
            )}
        />
    )
}
